import { Base } from '@studiometa/js-toolkit';

export default class SwatchColor extends Base {
    static config = {
        name: 'SwatchColor',
    };
    
    mounted() {
        // console.log(this.$el);
        // alert('test');
        const style = this.$el.getAttribute('style');
        if (style && !style.includes('#')) {
            this.$el.classList.add('tw-hidden');
        }
    }
    
}
